// BillingCancel Page
// Handles cancelled Stripe payment redirects

import { useNavigate } from 'react-router-dom';
import { FiXCircle, FiArrowLeft } from 'react-icons/fi';
import { Button } from '../../components/ui/Button/Button';
import { Card } from '../../components/ui/Card/Card';
import styles from './BillingCancel.module.css';

export function BillingCancel() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Card className={styles.cancelCard}>
        <div className={styles.content}>
          <div className={styles.iconWrapper}>
            <FiXCircle className={styles.cancelIcon} />
          </div>
          
          <h1 className={styles.title}>Payment Cancelled</h1>
          
          <p className={styles.message}>
            Your payment was cancelled and your plan has not been changed.
          </p>
          
          <p className={styles.submessage}>
            You can try upgrading again anytime. If you encountered any issues,
            please contact our support team.
          </p>

          <div className={styles.actions}>
            <Button
              variant="primary"
              size="lg"
              onClick={() => navigate('/admin/billing/upgrade')}
            >
              <FiArrowLeft />
              Try Again
            </Button>
            <Button
              variant="ghost"
              size="lg"
              onClick={() => navigate('/admin/billing')}
            >
              Back to Billing
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}

